import { render, staticRenderFns } from "./bargainPrice.vue?vue&type=template&id=0c537c1a&scoped=true"
import script from "./bargainPrice.vue?vue&type=script&lang=js"
export * from "./bargainPrice.vue?vue&type=script&lang=js"
import style0 from "./bargainPrice.vue?vue&type=style&index=0&id=0c537c1a&prod&lang=less&scoped=true"
import style1 from "./bargainPrice.vue?vue&type=style&index=1&id=0c537c1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c537c1a",
  null
  
)

export default component.exports